import Avocado from "./Polygonart-NFT/Avocado.png";
import Labador from "./Polygonart-NFT/BlackLabrador.png";
import CrushedCan from "./Polygonart-NFT/CrushedCan.jpg";
import Deer from "./Polygonart-NFT/Deer.png";
import DigitalBust from "./Polygonart-NFT/DigitaBust.jpg";
import Distortion from "./Polygonart-NFT/Distorttion.png";
import Elephant from "./Polygonart-NFT/Elephant.png";
import GermanShepperd from "./Polygonart-NFT/German.jpg";
import GoldenEagle from "./Polygonart-NFT/GoldenEagle.jpg";
import Holy from "./Polygonart-NFT/Holyjpg.jpg";
import HumanArt from "./Polygonart-NFT/HumanArt.jpg";
import HumanGrid from "./Polygonart-NFT/HumanGrid.jpg";
import Heart from "./Polygonart-NFT/Love.jpg";
import Portrait from "./Polygonart-NFT/PortraitZone.jpg";
import HumanPortrait from "./Polygonart-NFT/Portrait.jpg";
import Rabbit from "./Polygonart-NFT/Rabbit.jpg";
import Skull from "./Polygonart-NFT/Skull.jpg";
import Waterfall from "./Polygonart-NFT/Waterfall.jpg";
import Wizard from "./Polygonart-NFT/Wizard.jpg";
import Artist from "./Polygonart-NFT/avatar.png";
import Space from "../ApeArt/Ape-NFT/SpaceBoredApe.png";
const items = [
  {
    id: 1,
    title: "Avocado",
    artist: "David",
    artistImage: Artist,
    image: Avocado,
    info: "Digital art of Avocado from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 2,
    title: "Labador",
    artist: "David",
    artistImage: Artist,
    image: Labador,
    info: "Digital art of a Labador from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },

  {
    id: 3,
    title: "Crushed Can",
    artist: "David",
    artistImage: Artist,
    image: CrushedCan,
    info: "Digital art of a Crushed Can from our PolygonArt collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 4,
    title: "Deer",
    artist: "David",
    artistImage: Artist,
    image: Deer,
    info: "Digital art of a Deer from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 5,
    title: "Digital Bust",
    artist: "David",
    artistImage: Artist,
    image: DigitalBust,
    info: "Digital art of Digital Bust from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 6,
    title: "Distortion",
    artist: "David",
    artistImage: Artist,
    image: Distortion,
    info: "Digital art of Distortion Prism from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 7,
    title: "Elephant",
    artist: "David",
    artistImage: Artist,
    image: Elephant,
    info: "Digital art of a Elephant from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },

  {
    id: 8,
    title: "German.S",
    artist: "David",
    artistImage: Artist,
    image: GermanShepperd,
    info: "Digital art of a German Sheppard from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },

  {
    id: 9,
    title: "GoldenEagle",
    artist: "David",
    artistImage: Artist,
    image: GoldenEagle,
    info: "Digital art of a Golden Eagle from our PolygonArt collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },

  {
    id: 10,
    title: "Holy",
    artist: "David",
    artistImage: Artist,
    image: Holy,
    info: "Digital art of Holy from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 11,
    title: "Human Art",
    artist: "David",
    artistImage: Artist,
    image: HumanArt,
    info: "Digital art of Human Art from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 12,
    title: "Human Grid",
    artist: "David",
    artistImage: Artist,
    image: HumanGrid,
    info: "Digital art of a Human Grid from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 13,
    title: "Heart",
    artist: "David",
    artistImage: Artist,
    image: Heart,
    info: "Digital art of Heart from our PolygonArt collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },

  {
    id: 14,
    title: "Portrait",
    artist: "David",
    artistImage: Artist,
    image: Portrait,
    info: "Digital art of a Portrait from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 15,
    title: "Human Portrait",
    artist: "David",
    artistImage: Artist,
    image: HumanPortrait,
    info: "Digital art of a Human Portrait from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 16,
    title: "Rabbit",
    artist: "David",
    artistImage: Artist,
    image: Rabbit,
    info: "Digital art of a Rabbit from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },

  {
    id: 17,
    title: "Skull",
    artist: "David",
    artistImage: Artist,
    image: Skull,
    info: "Digital art of a Skull from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },

  {
    id: 18,
    title: "Waterfall",
    artist: "David",
    artistImage: Artist,
    image: Waterfall,
    info: "Digital art of a Waterfall from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 19,
    title: "Wizard",
    artist: "David",
    artistImage: Artist,
    image: Wizard,
    info: "Digital art of a Wizard from our PolygonArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "PolygonArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
];
export default items;
